import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Output,
  EventEmitter
} from '@angular/core';
import { PerfilService } from '../../../services/perfil.service';
import { MapaService } from '../../../services/mapa.service';
import { ModalMensajeComponent } from '../modal-mensaje/modal-mensaje.component';

@Component({
  selector: 'app-datos-usuario',
  templateUrl: './datos-usuario.component.html',
  styleUrls: ['./datos-usuario.component.css']
})
export class DatosUsuarioComponent implements OnInit {

  mostrarModalDireccionEntrega: boolean = false;
  mostrarModalDatosFacturacion: boolean = false;
  provincias: any[];
  municipios: any[];
  valueProvincia: any = null;
  valueMunicipio: any = null;
  valueProvinciaFacturacion: any = null;
  valueMunicipioFacturacion: any = null;
  filteredMunicipios: any[];
  filteredMunicipiosFacturacion: any[];
  refModalMensaje: any = {};
  datosValidos: boolean = false;

  direccionEntrega: any = {
    dni_cif: "",
    nombre: "",
    apellidos: "",
    direccion: "",
    codigoPostal: "",
    telefono: "",
    email: "",
    provincia: null,
    municipio: null
  };

  datosFacturacion: any = {
    nombre: "",
    apellidos: "",
    direccion: "",
    codigoPostal: "",
    telefono: "",
    provincia: null,
    municipio: null
  };

  user: any;

  @Input() mostrarCheckbox: boolean = false;

  @Output() userCargado = new EventEmitter<any>();

  @ViewChild('modalMensaje', { read: ViewContainerRef, static: false }) entry: ViewContainerRef;

  constructor(
    private pService: PerfilService,
    private mapService: MapaService,
    private resolver: ComponentFactoryResolver
  ) { }

  ngOnInit() {
    let userLogin = JSON.parse(localStorage.getItem("user"));

    console.log(this.mostrarCheckbox);

    if (userLogin != null) {
      this.getDatosUser(userLogin.id);
    } else {
      this.getDatosFormulario();
    }
  }

  getDatosUser(userId: number) {
    this.pService.getUserPerfil(userId).subscribe(result => {

      if (result.result == "ok") {

        this.user = result.user;

        this.direccionEntrega.dni_cif = this.user.nif_cif;
        this.direccionEntrega.nombre = this.user.name;
        this.direccionEntrega.apellidos = this.user.apellidos;
        this.direccionEntrega.direccion = this.user.direccion;
        this.direccionEntrega.codigoPostal = this.user.cp;
        this.direccionEntrega.telefono = this.user.telefono;
        this.direccionEntrega.email = this.user.email;
        this.direccionEntrega.municipio = this.user.municipio;
        if(this.user.municipio != null){
          this.direccionEntrega.provincia = this.user.municipio.provincia;
        }

        this.validarDatos();

        this.userCargado.emit( this.direccionEntrega);

        this.datosFacturacion.nombre = this.user.nombre_facturacion == null ? "" : this.user.nombre_facturacion;
        this.datosFacturacion.apellidos = this.user.apellidos_facturacion == null ? "" : this.user.apellidos_facturacion;
        this.datosFacturacion.direccion = this.user.direccion_facturacion == null ? "" : this.user.direccion_facturacion;
        this.datosFacturacion.cp = this.user.cp_facturacion == null ? "" : this.user.cp_facturacion;
        this.datosFacturacion.telefono = this.user.telefono_facturacion == null ? "" : this.user.telefono_facturacion;
        this.datosFacturacion.municipio = this.user.municipio_facturacion;
        this.datosFacturacion.provincia = this.user.municipio_facturacion == null ? null : this.user.municipio_facturacion.provincia;


        this.mapService.getProvincias().subscribe((provincias) => {
          provincias.unshift({ id: "", text: "" });
          this.provincias = provincias;
          let userProvincia = JSON.parse(JSON.stringify(this.user.municipio));
          let userProvinciaFacturacion = JSON.parse(JSON.stringify(this.user.municipio_facturacion));


          if (userProvincia != null) {
            this.valueProvincia = JSON.parse(JSON.stringify(this.user.municipio.provincia.id));
          }

          if (userProvinciaFacturacion != null) {
            this.valueProvinciaFacturacion = JSON.parse(JSON.stringify(this.user.municipio_facturacion.provincia.id));
          }

        });

        this.mapService.getMunicipios().subscribe((municipios) => {
          municipios.unshift({ id: '', text: "" });
          this.municipios = municipios;

          if (this.user.municipio != null) {
            if (this.user.municipio.provincia.id != undefined && this.user.municipio.provincia.id != null && this.user.municipio.provincia.id != 0) {
              this.onProvinciaChange({ value: this.user.municipio.provincia.id });
              this.valueMunicipio = JSON.parse(JSON.stringify(this.user.municipio.id));
            }
          }

          if (this.user.municipio_facturacion != null) {
            if (this.user.municipio_facturacion.provincia.id != undefined && this.user.municipio_facturacion.provincia.id != null && this.user.municipio_facturacion.provincia.id != 0) {
              this.onProvinciaFacturacionChange({ value: this.user.municipio_facturacion.provincia.id });
              this.valueMunicipioFacturacion = JSON.parse(JSON.stringify(this.user.municipio_facturacion.id));
            }
          }

        });

      } else {
        this.mostrarMensajeModal("Datos de usuario", "Se ha producido un error al obtener los datos del usuario");
      }
    });
  }

  validarTelefono(telefono: string): boolean {
    if (!telefono) return false;
    
    // Expresión regular que valida solo números y máximo 9 dígitos
    const telefonoRegex = /^\d{9}$/;
    return telefonoRegex.test(telefono);
  }
  
  /**
   * Maneja el evento keypress para permitir solo números en el campo teléfono
   * @param event - Evento del teclado
   */
  onTelefonoKeypress(event: KeyboardEvent): void {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Permitir solo números (0-9), backspace, delete, tab, escape, enter
    const allowedKeys = [8, 9, 27, 13, 46]; // backspace, tab, escape, enter, delete
    const isNumber = /[0-9]/.test(char);
    
    if (!isNumber && allowedKeys.indexOf(charCode) === -1) {
      event.preventDefault();
      return;
    }
    
    // Verificar longitud máxima (9 dígitos)
    const currentValue = (event.target as HTMLInputElement).value;
    if (currentValue.length >= 9 && !allowedKeys.includes(charCode)) {
      event.preventDefault();
    }
  }
  
  /**
   * Maneja el evento input para validar el teléfono en tiempo real
   * @param event - Evento de input
   */
  onTelefonoInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Remover cualquier carácter que no sea número
    value = value.replace(/\D/g, '');
    
    // Limitar a 9 dígitos
    if (value.length > 9) {
      value = value.substring(0, 9);
    }
    
    // Actualizar el valor en el modelo
    this.direccionEntrega.telefono = value;
    input.value = value;
    
    // Revalidar datos
    this.validarDatos();
  }
  
  validarDatos() {

    console.log(this.direccionEntrega);

    const telefonoValido = this.validarTelefono(this.direccionEntrega.telefono);
    
    if(this.direccionEntrega.nombre != "" &&
       this.direccionEntrega.apellidos != "" && 
       this.direccionEntrega.direccion != "" && 
       this.direccionEntrega.codigoPostal != "" && 
       telefonoValido && 
       this.direccionEntrega.email != "" && 
       this.direccionEntrega.municipio != null &&
       this.direccionEntrega.municipio.id != null &&
       this.direccionEntrega.provincia != null &&
       this.direccionEntrega.dni_cif != "" &&
       this.direccionEntrega.dni_cif != null) 
    {
          this.datosValidos = true;
    } else {
      this.datosValidos = false;
    }
  }

  getDatosFormulario() {
    this.mapService.getProvincias().subscribe((provincias) => {
      provincias.unshift({ id: "", text: "" });
      this.provincias = provincias;
      let userProvincia = JSON.parse(JSON.stringify(this.direccionEntrega.municipio));

      if (userProvincia != null) {
        this.valueProvincia = JSON.parse(JSON.stringify(this.direccionEntrega.municipio.provincia.id));
      }

    });

    this.mapService.getMunicipios().subscribe((municipios) => {
      municipios.unshift({ id: '', text: "" });
      this.municipios = municipios;

      /*if (this.user.municipio != null) {
        if (this.user.municipio.provincia.id != undefined && this.user.municipio.provincia.id != null && this.user.municipio.provincia.id != 0) {
          this.onProvinciaChange({ value: this.user.municipio.provincia.id });
          this.valueMunicipio = JSON.parse(JSON.stringify(this.user.municipio.id));
        }
      }*/

    });
  }

  onProvinciaChange(value) {

    this.valueProvincia = value.value;

    if (value != undefined && value.value != "") {

      let nombreProvincia = this.getNombreProvincia(value.value);

      if (this.direccionEntrega.municipio == null) {

        this.direccionEntrega.municipio = {
          id: "",
          provincia: {
            id: value.value,
            nombre: nombreProvincia,
            text: nombreProvincia
          }
        };
      } else {
        this.direccionEntrega.municipio.provincia.id = value.value;
        this.direccionEntrega.municipio.provincia.nombre = nombreProvincia;
        this.direccionEntrega.municipio.provincia.text = nombreProvincia;
      }
    } else {
      if (this.direccionEntrega.municipio == null) {
        this.direccionEntrega.municipio = {
          id: "",
          provincia: {
            id: null,
            nombre: "",
            text: ""
          }
        };
      } else {
        this.direccionEntrega.municipio.provincia.id = this.valueProvincia;
        this.direccionEntrega.municipio.provincia.nombre = "";
        this.direccionEntrega.municipio.provincia.text = "";
      }



    }

    if (this.municipios != undefined) {
      this.valueMunicipio = null;
      this.filteredMunicipios = this.municipios.filter(
        (municipio) => +municipio.id_provincia === +value.value
      );

      this.filteredMunicipios.unshift({ id: '', text: "" });

    }

  }

  getNombreProvincia(id) {
    for (let provincia of this.provincias) {
      if (provincia.id == id) {
        return provincia.nombre;
      }
    }
  }

  getNombreMunicipio(id) {
    for (let municipio of this.municipios) {
      if (municipio.id == id) {
        return municipio.nombre;
      }
    }
  }

  onProvinciaFacturacionChange(value) {

    if (value != undefined && value.value != "") {
      let nombreProvincia = this.getNombreProvincia(value.value);
      if (this.datosFacturacion.municipio == null) {

        let provincia = {
          id: value.value,
          nombre: nombreProvincia,
          text: nombreProvincia
        };

        this.datosFacturacion.municipio = {
          id: "",
          provincia: provincia
        };

        this.datosFacturacion.provincia = provincia;


      } else {
        this.datosFacturacion.municipio.provincia.id = value.value;
        this.datosFacturacion.municipio.provincia.nombre = nombreProvincia;
        this.datosFacturacion.municipio.provincia.text = nombreProvincia;

        this.datosFacturacion.provincia.id = value.value;
        this.datosFacturacion.provincia.nombre = nombreProvincia;
        this.datosFacturacion.provincia.text = nombreProvincia;
      }
    } else {
      if (this.datosFacturacion.municipio == null) {
        this.datosFacturacion.municipio = {
          id: "", provincia: {
            id: null,
            nombre: "",
            text: ""
          }
        };

        this.datosFacturacion.provincia = {
          id: null,
          nombre: "",
          text: ""
        };
      } else {
        this.datosFacturacion.municipio.provincia.id = this.valueProvincia;
        this.datosFacturacion.municipio.provincia.nombre = "";
        this.datosFacturacion.municipio.provincia.text = "";

        this.datosFacturacion.provincia.id = this.valueProvincia;
        this.datosFacturacion.provincia.nombre = "";
        this.datosFacturacion.provincia.text = "";
      }

    }

    if (this.municipios != undefined) {
      this.filteredMunicipiosFacturacion = this.municipios.filter(
        (municipio) => +municipio.id_provincia === +value.value
      );

      this.filteredMunicipiosFacturacion.unshift({ id: '', text: "" });

    }

  }

  onMunicipioChange(value) {
    let nombreMunicipio = this.getNombreMunicipio(value.value);
    this.valueMunicipio = value.value;
    this.direccionEntrega.municipio.id = value.value;
    this.direccionEntrega.municipio.nombre = nombreMunicipio;
    this.direccionEntrega.municipio.text = nombreMunicipio;
  }

  onMunicipioFacturacionChange(value) {
    let nombreMunicipio = this.getNombreMunicipio(value.value);
    this.datosFacturacion.municipio.id = value.value;
    this.datosFacturacion.municipio.nombre = nombreMunicipio;
    this.datosFacturacion.municipio.text = nombreMunicipio;
  }

  abrirModalDireccionEntrega() {
    this.mostrarModalDireccionEntrega = true;
  }

  cerrarModalDireccionEntrega() {
    this.validarDatos();
    this.mostrarModalDireccionEntrega = false;
  }

  abrirModalDatosFacturacion() {
    this.mostrarModalDatosFacturacion = true;
  }

  cerrarModalDatosFacturacion() {
    this.mostrarModalDatosFacturacion = false;
  }

  mostrarMensajeModal(titulo, mensaje) {
    this.entry.clear();
    const factory = this.resolver.resolveComponentFactory(ModalMensajeComponent);
    this.refModalMensaje = this.entry.createComponent(factory);
    this.refModalMensaje.instance.mensaje = mensaje;
    this.refModalMensaje.instance.titulo = titulo;
    this.refModalMensaje.changeDetectorRef.detectChanges();
  }

  guardarDatos() {

    if(this.mostrarCheckbox==false || this.mostrarCheckbox && this.direccionEntrega.establecer_defecto==true){
      this.user.name = this.direccionEntrega.nombre;
      this.user.apellidos = this.direccionEntrega.apellidos;
      this.user.direccion = this.direccionEntrega.direccion;
      this.user.cp = this.direccionEntrega.codigoPostal;
      this.user.telefono = this.direccionEntrega.telefono;
      this.user.email = this.direccionEntrega.email;
      this.user.municipio = this.direccionEntrega.municipio;
      this.user.nif_cif = this.direccionEntrega.dni_cif;

      this.pService.editarPerfil(this.user).subscribe(result => {
        if ((<any>result).result == "ok") {
          this.user = (<any>result).user;
          localStorage.setItem("user", JSON.stringify(this.user));
          this.userCargado.emit(this.direccionEntrega);
          this.validarDatos();
          this.cerrarModalDireccionEntrega();
          this.mostrarMensajeModal("Dirección de entrega principal actualizada", "Se ha actualizado la dirección de entrega principal en su usuario.");
        } else if ((<any>result).result == "exist") {
          this.mostrarMensajeModal("Editar contacto y dirección de entrega", "No se ha guardado los cambios porque el email ya existe.");
        } else if ((<any>result).result == "existUsuario") {
          this.mostrarMensajeModal("Editar contacto y dirección de entrega", "No se ha guardado los cambios porque el nombre de usuario ya existe.");
        } else {
          this.mostrarMensajeModal("Editar contacto y dirección de entrega", "Se ha producido un error al editar el perfil.");
        }
  
      });
    }else{
        this.userCargado.emit(this.direccionEntrega);
        this.cerrarModalDireccionEntrega();
    }

  }

  autoResize(event: any): void {

    console.log("entro");
    const textarea = event.target;
    
    textarea.style.height = '45px';
    
    const newHeight = Math.max(45, textarea.scrollHeight);
    textarea.style.height = newHeight + 'px';
  }

}
